<template>
  <Modal :id="'cmp-file-uploader'" @cancelled="onCancelClick">
    <template slot="header"
      >Files</template
    >
    <template slot="body">
      <FileDropzone @filedrop="onFileDropped">
        <!-- <div class="dt-modal--subtitle">Upload New File</div> -->
        <v-layout v-if="!this.file" row wrap class="file-section">
          <div class="button-container">
            <button
              class="dt-button s4 select-file"
              id="selectNewFile"
              @click="onSelectNewFile"
            >
              <div class="dt-icon-container">
                <img src="static/icons/plus.svg" class="dt-icon v7" alt />
              </div>
              <span class="button-text">Select New File</span>
            </button>
            <input
              type="file"
              id="filepicker"
              @change="onFilePickerChange"
              style="visibility: hidden; display: none"
              name="filepicker"
            />
          </div>
          <div class="middle-or">
            <div>or</div>
          </div>
          <div class="file-dropzone">
            <div class="dt-icon-container">
              <img
                src="static/icons/modal/document-grey.svg"
                class="dt-icon v7"
                alt
              />
            </div>
            <span class="dropzone-text" v-if="!file">Drag & Drop</span>
            <!-- <div v-else class="file-info">
              <span class="file-name">{{file.name}}</span>
              <span class="file-size">({{formatBytes(file.size)}})</span>
            </div> -->
          </div>
        </v-layout>
        <div class="file-upload-list">
          <v-layout
            class="file-upload-list-item"
            v-if="file && !fileUploadingFlag"
            row
            wrap
          >
            <div class="dt-icon-container">
              <img
                src="static/icons/modal/document-grey.svg"
                class="dt-icon v7"
                alt
              />
            </div>
            <div class="file-name vermid2">
              {{ file.name }}
            </div>
            <div v-if="!isValidExtension" class="file-description">
              Only {{allowedTypeString}} file format supported
            </div>
          </v-layout>
        </div>

        <div class="ut-colcen" v-if="fileUploadingFlag" style="height: 85px">
          <div class="ut-rowcen">
            <img src="static/icons/loading.gif" alt />
          </div>
        </div>

        <div class="ut-rowcen" v-if="instruction!=''" style="height: 85px;justify-content: left;margin-top: 15px;">
          <p style="margin-bottom: 0px;">
            {{instruction}}
          </p>
        </div>

      </FileDropzone>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">Cancel</button>
      <button
        class="dt-button v1 s6"
        @click="onOKClick"
        :disabled="okButtonDisabled"
        :class="{
          disabled: okButtonDisabled
        }"
      >
        OK
      </button>
    </template>
  </Modal>
</template>

<script>
// import vueDropzone from "vue2-dropzone";

import Dropdown from "@plugins/dropdown/dropdown";
import TextField from "@plugins/text-field/text-field";
import InputField from "@plugins/text-field/input-field";
import FileDropzone from "@dtplugins/file-uploader/file-dropzone";

import { FileService } from "@dtplugins/file-uploader/file.service";
import { unrelatedDocumentView } from "@dtplugins/file-uploader/file.model";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { addRemoveSet, formatBytes, snakeCaseToWords } from "../../utility";

import Modal from "../modal/modal";

export default {
  components: {
    InputField,
    // vueDropzone,
    FileDropzone,
    Modal
  },
  props: {
    allowedType: {
      default: () => [],
      type:Array
    
    },
    instruction: {
      default: () => "",
      type:String
    
    },
    externalId: {
     
    },
    externalTable: {
     
    }
  },
  data: function() {
    return {
      selectedFiles: new Set(),
      dropZoneOptions: {
        url: "https://staging.detailsdetails.eu/berlin3/files.pl",
        withCredentials: true,
        autoProcessQueue: false,
        maxFiles: 1,
        paramName: "file_name",
        createImageThumbnails: false
      },
      files: [],
      file: null,
      fileObjects: [],
      fileDescription: "",

      fileInternalUse: "0",

      fileUploadingFlag: false,
      documentRelationLoadingFlag: false
    };
  },
  mounted: async function() {
    // if (this.isShowChooseExisting) {
    //   const fileResponse = await FileService.findUnrelatedFileList({
    //     externalId: this.externalId,
    //     externalTable: this.externalTable
    //   });

    //   this.files = unrelatedDocumentView(fileResponse);

    //   this.$subscribeTo(
    //     this.searchSubject$.asObservable().pipe(
    //       distinctUntilChanged(),
    //       debounceTime(500)
    //     ),
    //     searchString => {
    //       FileService.findFileByName({
    //         key: searchString,
    //         externalId: this.externalId,
    //         externalTable: this.externalTable
    //       }).then(res => {
    //         this.files = unrelatedDocumentView(res);
    //       });
    //     }
    //   );
    // }
  },
  computed: {
    isShowChooseExisting: function() {
      // return true;
      return this.externalId && this.externalTable ? true : false;
    },
    isValidExtension:function(){
      const extension = this.file.name.split('.').pop();
      //console.log(":::",this.allowedType.find(extension))
      return this.allowedType.length>0 && this.allowedType.find(e=>e==extension)?true:false;
    },

    allowedTypeString:function(){
      return this.allowedType.reduce((accum,cur)=>{
          accum+=`${cur}/`
          return accum
      },'').slice(0, -1)
    },
    okButtonDisabled() {
      return this.file && !this.fileUploadingFlag && this.isValidExtension
        ? false
        : this.selectedFiles.size < 1;
    },
    // order_id:function(){
    //   return this.$route.query.order_id
    // }



  },
  methods: {

    onCancelClick: function(event) {
      this.resetData();
      this.$emit("cancelled", true);
    },
    onOKClick: function(event) {
      console.log("dfile file-upl onOKClick", this.file);
      this.$emit("upload",{ file:this.file })

      // if (this.file && !this.fileUploadingFlag) {
      //   this.uploadFile();
      // } else {
      //   this.createDocumentRelation();
      // }
    },
    createDocumentRelation() {
      const selectedFiles = Array.from(this.selectedFiles);
      if (selectedFiles.length === 0) {
        return;
      }
      this.documentRelationLoadingFlag = true;
      FileService.insertDocumentRelation({
        externalId: this.externalId,
        fileIds: selectedFiles.join(","),
        externalTable: this.externalTable
      }).then(res => {
        this.documentRelationLoadingFlag = false;
        // this.$emit("done", res);
        this.emitFileDone(res);
      });
    },
    emitFileDone(res) {
      this.$emit("done", {
        res,
        externalId: this.externalId,
        externalTable: this.externalTable
      });
    },
    onSelectNewFile: function(event) {
      // document.querySelector('#fileDropzone').click();
      document.querySelector("#filepicker").click();
    },
    fileAdded: function(file) {
      console.log(file, this.$refs.fileDropzone);
      this.file = file;
      const size = formatBytes(file.size);
    },
    formatBytes: function(size) {
      return formatBytes(size);
    },
    fileSending: function(file, xhr, formData) {
      //formData.append("returnType", "json");
      formData.append("external_id", this.externalId);
      formData.append("external_table", this.externalTable);
      formData.append("action", "upload_document_new");
      formData.append("section", "bookings");
      formData.append("file_description", "");
      formData.append("private", 0);
    },
    onUploadFile: function(event) {
      // this.$refs.fileDropzone.processQueue();
      this.uploadFile();
    },
    resetData: function() {
      this.file = null;
      this.selectedFiles = new Set();
      this.fileDescription = "";
   
    },
    onCancelUpload: function(event) {
      this.resetData();
      this.$emit("cancelled", true);
      this.$refs?.fileDropzone?.removeAllFiles();
    },
    fileUploadSuccess: function(res) {
      // this.$emit("done", res);
      this.emitFileDone(res);
    },
    constructFormDataFromFile: function(file) {
      // console.log(file);
      const formData = new FormData();

      formData.append("file_name", file);

      formData.append("returnType", "json");
      formData.append("output", "json");
      formData.append("external_id", this.externalId);
      formData.append("external_table", this.externalTable);
      formData.append("action", "upload_document_new");
      formData.append("section", "bookings");
      formData.append("file_description", this.fileDescription || file.name);
      formData.append("private", this.fileInternalUse);

      return formData;
    },
    uploadFile: function() {
      // const files = this.file;

      const formData = this.constructFormDataFromFile(this.file);
      // console.log(this.file);
      this.fileUploadingFlag = true;
      FileService.uploadFile(formData).then(res => {
        this.fileUploadingFlag = false;
        console.log({
          res: res,
          isShowChooseExisting: this.isShowChooseExisting
        });
        this.emitFileDone(res);
        this.resetData();
        if (this.isShowChooseExisting) {
          // this.$emit("done", res);
        } else {
          this.onCancelUpload();
        }
      });
    },

    uploadAllFiles: function() {
      // for (const index in this.fileObjects) {
      //   const formData = this.constructFormDataFromFile(this.fileObjects[index]);
      //   const onUploadProgress = (event) => {
      //     this.fileObjects[index].percentage = parseInt(Math.round(event.loaded * 100 / event.total));
      //     console.log(this.fileObjects[index].percentage);
      //   }
      //   FileService.uploadFile(formData, onUploadProgress).then(res => {
      //   });
      // }
    },

    onFileDropped: function(files) {
      if (files.length == 0) {
        return;
      }
      const file = files[0];
      this.file = file;

      // After Multiple File is supported
      // this.fileObjects = files.map(e => ({file: e}));
    },
    onFilePickerChange: function(event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.file = files[0];
      }
    },

    snakeCaseToWords: snakeCaseToWords

    //MARK: Methods
  }
};
</script>

<style lang="scss" scoped>
.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  // --ntable-height: 0px;
  // --ntable-rowHeight: 40px;
  // --ntable-background: var(--col-l10);
  // --ntable-theadr-right: 0px;
  // --ntable-hover-color: inherit;
  // --ntable-td-padding: 0px 10px;
  // --ntable-th-padding: 0px 10px;
  // --ntable-th-span-padding: 0px;
  --ntable-th-span-margin: 0px 10px;
  --ntable-td-span-margin: 0px 10px;

  margin-top: 10px;
  --row-margin: 0px;
  --row-padding: 0px;
  --row-margin-header: 0;

  --ntable-theadr-right: 17px;

  .dt-table2--row {
    margin: var(--row-margin-header) !important;
    padding: var(--row-padding);

    .dt-table2--column {
    }
  }

  thead {
    .dt-table2--row {
      padding-right: var(--ntable-theadr-right);
    }
  }

  tbody {
    min-height: 380px;
  }

  th {
    & > span,
    & > div {
      margin: var(--ntable-th-span-margin);
    }
  }

  td {
    & > span,
    & > div {
      margin: var(--ntable-td-span-margin);
    }
  }

  .dt-table2--column {
    &:first-child {
      flex: 0.15;
    }
    &:last-child {
      flex: 0.5;
    }
    &.file-name {
      flex: 1.7;
    }
  }
}

.section-name {
  color: var(--text-3);
  margin: 15px 0px;

  &.upload-new {
    margin-top: 0px;
  }
}

.file-section {
  margin-left: -8px;
  .button-container {
    display: flex;
    flex-direction: column;
    justify-content: center;

    button.select-file {
      display: flex;
      width: 138px;

      .dt-icon-container {
        // img {
        //   padding: 2px;
        // }
      }

      .button-text {
        // margin-left: 8px;
        margin-top: auto;
        margin-bottom: auto;
      }
    }
  }

  .file-dropzone {
    width: 150px;
    height: 60px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    text-align: center;
    border: 1px dashed var(--sprt-4);

    .dt-icon-container {
      margin-left: auto;
      margin-right: auto;

      height: 30px;
      margin-top: 2px;
    }

    .dropzone-text {
      color: var(--col-d9);
    }
  }

  .file-info {
    display: flex;
    justify-content: center;
    .file-name {
      max-width: 90px;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 2px;
    }
    .file-size {
    }
  }
}
</style>

<style lang="scss">
.cmp-file-uploader {
  .file-upload-list {
    overflow: auto;
    max-height: 250px;

    .file-upload-list-item {
      padding: 5px 0px;

      &:not(:last-child) {
        border-bottom: 1px solid var(--sprt-85);
      }

      .file-name {
        //TEMP
        margin-right: 30px;
      }
      .file-bar {
        display: flex;
        margin-left: 12px;
        // margin-right: 50px;

        .progress-bar-container {
          width: 60px;
          height: 5px;

          margin-right: 12px;
          border-radius: 30px;
          background: gray;
        }
        .file-close {
        }
      }
      .file-description {
        flex: 1;
        // width: 230px;
        margin-top: 5px;
        //TEMP
        //min-width: 252px;
        //max-width: 272px;
      }
      .file-internal {
        display: flex;
        margin-left: 15px;

        .file-internal-text {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
